import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

import { AppUserAuth } from '../models/user.model';
import { DataProvider } from '../providers/data.provider';
import { AppUser } from './../models/user.model';

@Injectable()
export class SessionService {

    private _httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(
        private readonly _http: HttpClient,
        private readonly _dataProvider: DataProvider) { }

    public login(user: AppUser) {
        return this._http.post<AppUserAuth>(environment.apiEndpoint + '/Login/Authenticate', user);
    }

    public refreshToken (refreshToken): Observable<AppUserAuth> {
        return this._http.post<AppUserAuth>(environment.apiEndpoint + '/Login/RefreshToken', refreshToken);
    }

    public verificationCode(verification) {
        return this._http.post<any>(environment.apiEndpoint + '/Login/VerifyTwoFactorEmailTokenObject', verification);
    }

    public passwordRecovery(user) {
        return this._http.get<any>(environment.apiEndpoint + '/ApplicationUser/PasswordRecovery?userName=' + user);
    }

    public passwordRecoveryReset(credentials) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/PasswordRecoveryReset', credentials);
    }

    public changeCurrentPassword(credentials) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/ChangeCurrentUserPassword', credentials);
    }

    public confirmRegistration(registration) {
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/AppUserSolicitudRegistroConfirmacion', registration);
    }

    public logout() {
        window.location.reload();
        // Borramos todas las claves salvo la de estilos personalizados
        if (localStorage.getItem("url")) {
            localStorage.removeItem("url");
        }
        if (localStorage.getItem("base64")) {
            localStorage.removeItem("base64");
        }
        if (localStorage.getItem("defaultLanguage")) {
            localStorage.removeItem("defaultLanguage");
        }
        if (localStorage.getItem("refreshChangeLanguage")) {
            localStorage.removeItem("refreshChangeLanguage");
        }
        localStorage.removeItem("user");
        localStorage.removeItem("token");
    }

    public async loadDataProvider(): Promise<boolean> {
        return await this._dataProvider.load();
    }

    public getIdiomaAll(){
        return this._http.get<any>(environment.apiEndpoint + '/Idioma/GetAll');
    }

    public changeIdiomaUser(options){
        return this._http.post<any>(environment.apiEndpoint + '/ApplicationUser/ChangeCurrentUserIdioma', options);
    }

    // AYUDA
    public getDocHelp(nombreArchivo: string) {
      return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }

    public getFileDownload(nombreArchivo: string) {
      return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetFileDownload/?nombreArchivo=' + nombreArchivo);
    }

    public getNotificacionesPendientes(notificationsNumber) {
        return this._http.get<any>(environment.apiEndpoint + '/NotificacionWeb/GetPendienteLectura/?tamPagina=' + notificationsNumber);
    }

    public getCustomStyles(filters) {
      return this._http.post<any>(environment.apiEndpoint + "/EstiloFront/GetFirstConFiltro", filters);
    }

    public getCustomStyle(styleId: number) {
      return this._http.get<any>(environment.apiEndpoint + "/EstiloFront/GetById/?estiloFrontId" + styleId);
    }

    public createCustomStyle(filters) {
      return this._http.post<any>(environment.apiEndpoint + "/EstiloFront", filters);
    }

    public updateCustomStyle(filters) {
      return this._http.put<any>(environment.apiEndpoint + "/EstiloFront", filters);
    }

    public deleteCustomStyle(id) {
      return this._http.delete<any>(environment.apiEndpoint + "/EstiloFront/?id=" + id);
    }

    public getAuditorEmailSubscription(filters) {
        return this._http.post<any>(environment.apiEndpoint + "/Auditor/GetAllConFiltro", filters);
    }

    public updateAuditorEmailSubscription(filters) {
        return this._http.post<any>(environment.apiEndpoint + "/ApplicationUserAlerta/InsUpd_AppUserAlertaByUserName", filters);
    }
}
